import { render, staticRenderFns } from "./TabPage.vue?vue&type=template&id=1e0e6da2&"
import script from "./TabPage.vue?vue&type=script&lang=js&"
export * from "./TabPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports